import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header-menu.component.html',
  standalone: false,
})
export class HeaderMenuComponent implements OnInit {
  ngOnInit() {

  }
}
